export default "__VITE_ASSET__Mx$wg7dP__"